import { EntityApiService } from '@dfl/react-security';
import { ILabels } from 'modules/inventory/settings/labels/interfaces';

class LabelsService extends EntityApiService<ILabels> {}

export default new LabelsService('/ms-inventory/api/labels');
